import * as rdd from 'react-device-detect'

export const isMobile = (): boolean => {
  return rdd.isMobile
}
